// extracted by mini-css-extract-plugin
export default {"statsBar":"home_statsBar__Brl+d","stat":"home_stat__K5Gd1","number":"home_number__QIS78","tablet":"home_tablet__UnupP","mobile":"home_mobile__oG11X"};